import {useAuth} from '@brg/auth';
import {LayoutConst, useModal} from 'core';
import React, {FC, useMemo} from 'react';
import {useHistory} from 'react-router-dom';
import {SendProjectButton} from '../../../../_competition/components/SendProjectButton';
import {HintTooltip, useToasts, useBreakpoint} from "@brg/ui";
import {useTheme} from "styled-components";
import { AppTester } from 'supporting';
import { useTranslation } from 'react-i18next';
import { API, Endpoints, Nullable } from "@brg/api";
import ReactTooltip from 'react-tooltip';
import { getTooltipStyles } from 'shared/constants/tooptipStyles';
import { ActionsButtonWrapper } from './style';
import { AllowedData } from 'shared/hooks/useGetLimitSendCompetition';


const hintProps: any = {
    noArrow: true,
    positionY: 'bottom',
  };

export enum CompetitionDisableBtnStatus {
    max_projects = 'max_projects',
    max_briefs = 'max_briefs',
    participant = 'participant',
    participant_pending = 'participant_pending',
    none = 'none'
}

interface IActionsProps extends AllowedData {
 isModer: boolean;
 id: string | undefined;
 needAuth?: boolean;
 disabled?: boolean;
 fullWidth?: boolean;
 isPreRegistration?: boolean;
 isAllowParticipants?: boolean;
 isBriefPreregistration?: boolean;
 nominationId?: string;
 contexts?: Nullable<string[]>;
 text?: string;
}

const INTERIOR_DESIGN_COMPETITION_IDS = [
  '2c34388c67ef4effba5073eb687c1921',
  'd743f26276804e6a8ba8c5cb6cc6897f',
  '2e88a0cba1ff46e89b9089a7b474d859',
  '2d0f91c5672c4b7198d0ba8ce824cf40',
  'a7a6b8d4b770468d82ffce5104faaa48',
]

const GREEN_AWARDS_COMPETITION_IDS = [
    "42493d2f77a84bf9a0f465451df71ff9",
    "8edf1a5a40e94e489fc79a7de29e864c",
    "8b7c88b557dd4a5b90dad959b205104e",
    "8461cb11b0724f6790280fd1c159137f",
    "c9b7f61ee5e349f495dfe237dd3109df",
    "9b26f859c5734929bdbc3f21a6570a10",
    "8b120248cd494750814b42bse1f0acd9",
    "348fda0aace24dc28cd5c5ffe77cf230",
    "9b6eb324b573410bbde5b570046433b2",
    "f56f6fe5f716482e8230146098423d51",
    "8b120248cd494750814b42b361f0acd9",
    "31235d97ac974536b6661c829a673e10"
];

const ActionsButtons: FC<IActionsProps> = ({ 
    isModer, 
    needAuth, 
    id, 
    contexts, 
    disabled, 
    fullWidth, 
    isPreRegistration,
    isAllowParticipants, 
    isBriefPreregistration,
    nominationId,
    text,
    ...rest 
}) => {
    const modal = useModal();
    const { t, i18n } = useTranslation();
    const history = useHistory();
    const toasts = useToasts();
    const auth = useAuth();
    const theme = useTheme();
    const isGenius = contexts?.includes?.('genius');
    const isAcademy = AppTester.isAcademy() && !isGenius;
    const isKiiids = AppTester.isKiiidsArt()
    const isGreenAward = AppTester.isGreenAward()
    const is743 = useBreakpoint(LayoutConst.screen.s - 1);

    const { allowedInfo, allowedStatus } = rest;

    // console.log('competition', rest, id)

    const disableMsg: string = useMemo(
        //@ts-ignore
        () => {
            return (
                allowedInfo && !!allowedInfo?.length ? 
                t(`competition.allowed_messages.${allowedInfo?.[0]}_${isModer ? 'moder' : 'user'}`) : 
                '' 
            )

        } , [isModer, t, i18n.language, allowedInfo])


    const allowedProjectsCount = useMemo(
        () => allowedStatus?.allowedMax && allowedStatus?.allowedMax > 0 ? <span>{`${allowedStatus?.allowedCurrent} / ${allowedStatus?.allowedMax}`}</span> : '' 
    , [allowedStatus])

    return (
        <ActionsButtonWrapper>
             <HintTooltip  hidden={disableMsg === '' || isGreenAward} customStyle={getTooltipStyles(theme)} text={disableMsg} z={7} w={is743 ? '100%' : ''} onWhiteBg={true}  {...hintProps}>
            {isModer ? (
                <SendProjectButton
                color={theme.competition.buttonText}
                className='moder-button'
                c={theme.competition.buttonBg}
                hoverC={theme.competition.secondaryText}
                onClick={() => {    
                    history.push('/competition/' + id + "/moder")
                }}
                r="3"
                fullWidth={fullWidth}
            >
                {t('competition.moder')}
                {allowedProjectsCount}
            </SendProjectButton>
            ) : 
            isKiiids ?
            <></>
            :
            (
                <SendProjectButton
                color={theme.competition.buttonText}
                c={theme.competition.buttonBg}
                hoverC={theme.competition.secondaryText}
                disabled={disabled}
                className='send-button'
                fullWidth={fullWidth}
                onClick={() => {
                    if (INTERIOR_DESIGN_COMPETITION_IDS.includes(id)){
                      return history.push('/competitions/application/' + id)
                    }
                    if (needAuth) {
                        return auth.login()
                    }
                    if (GREEN_AWARDS_COMPETITION_IDS.includes(id)){
                        return modal.show('application-form', {
                            nominationIds: [nominationId],
                            callBack: () => window.location.reload(),
                            onClose: () => modal.hide(),
                            competitionId: id
                        })
                    }
                    if (isBriefPreregistration) {
                        const confirm = window.confirm(t('hse_showcases_title.competitions.msg.wont_send_requests'))
                        if (confirm) {
                            try {
                                API.request()
                                .endpoint(Endpoints.competitions)
                                .url('/api/Competition/RequestParticipantToCompetition')
                                .post()
                                .addQuery('competitionId', id || '')
                                .send()
                                .then((r) => {
                                  if (r?.status === 200) {
                                    modal.show('custom-info-modal', {
                                        title: t('hse_showcases_title.competitions.msg.success_brief_send'),
                                        text: t('hse_showcases_title.competitions.msg.success_brief_send_descriptions')
                                    })
                                  }
                      
                                })
                              }
                              catch(err) {
                                console.error('Что-то пошло не так');
                              }

                        }
                        return;
                    }
                    if (isPreRegistration) {
                        modal.show('competition-custom-legals', {
                            nominationIds: [nominationId],
                            callBack: () => window.location.reload(), 
                            onClose: () => modal.hide(),
                            competitionId: id
                        })
                    } else {
                        modal.show(
                            'send-project'
                            , {
                            id,
                            isPreRegistration,
                            isAllowParticipants,
                            onClose: () => modal.hide(),
                        })
                    }
                }} 
                r="3"
                >
                    {text?.length ? text : isAcademy ? t('competition.apply') : t('competition.submit')}
            </SendProjectButton>
            )}
            </HintTooltip>
            <ReactTooltip {...getTooltipStyles(theme as any)} arrowColor='transparent'/>
        </ActionsButtonWrapper>
    )
}

export default React.memo(ActionsButtons);import {useAuth} from '@brg/auth';
import {LayoutConst, useModal} from 'core';
import React, {FC, useMemo} from 'react';
import {useHistory} from 'react-router-dom';
import {SendProjectButton} from '../../../../_competition/components/SendProjectButton';
import {HintTooltip, useToasts, useBreakpoint} from "@brg/ui";
import {useTheme} from "styled-components";
import { AppTester } from 'supporting';
import { useTranslation } from 'react-i18next';
import { API, Endpoints, Nullable } from "@brg/api";
import ReactTooltip from 'react-tooltip';
import { getTooltipStyles } from 'shared/constants/tooptipStyles';
import { ActionsButtonWrapper } from './style';
import { AllowedData } from 'shared/hooks/useGetLimitSendCompetition';


const hintProps: any = {
    noArrow: true,
    positionY: 'bottom',
  };

export enum CompetitionDisableBtnStatus {
    max_projects = 'max_projects',
    max_briefs = 'max_briefs',
    participant = 'participant',
    participant_pending = 'participant_pending',
    none = 'none'
}

interface IActionsProps extends AllowedData {
 isModer: boolean;
 id: string | undefined;
 needAuth?: boolean;
 disabled?: boolean;
 fullWidth?: boolean;
 isPreRegistration?: boolean;
 isAllowParticipants?: boolean;
 isBriefPreregistration?: boolean;
 nominationId?: string;
 contexts?: Nullable<string[]>;
 text?: string;
}

const INTERIOR_DESIGN_COMPETITION_IDS = [
  '2c34388c67ef4effba5073eb687c1921',
  'd743f26276804e6a8ba8c5cb6cc6897f',
  '2e88a0cba1ff46e89b9089a7b474d859',
  '2d0f91c5672c4b7198d0ba8ce824cf40',
  'a7a6b8d4b770468d82ffce5104faaa48',
]

const GREEN_AWARDS_COMPETITION_IDS = [
    "42493d2f77a84bf9a0f465451df71ff9",
    "8edf1a5a40e94e489fc79a7de29e864c",
    "8b7c88b557dd4a5b90dad959b205104e",
    "8461cb11b0724f6790280fd1c159137f",
    "c9b7f61ee5e349f495dfe237dd3109df",
    "9b26f859c5734929bdbc3f21a6570a10",
    "8b120248cd494750814b42bse1f0acd9",
    "348fda0aace24dc28cd5c5ffe77cf230",
    "9b6eb324b573410bbde5b570046433b2",
    "f56f6fe5f716482e8230146098423d51",
    "8b120248cd494750814b42b361f0acd9",
    "31235d97ac974536b6661c829a673e10"
];

const ActionsButtons: FC<IActionsProps> = ({ 
    isModer, 
    needAuth, 
    id, 
    contexts, 
    disabled, 
    fullWidth, 
    isPreRegistration,
    isAllowParticipants, 
    isBriefPreregistration,
    nominationId,
    text,
    ...rest 
}) => {
    const modal = useModal();
    const { t, i18n } = useTranslation();
    const history = useHistory();
    const toasts = useToasts();
    const auth = useAuth();
    const theme = useTheme();
    const isGenius = contexts?.includes?.('genius');
    const isAcademy = AppTester.isAcademy() && !isGenius;
    const isKiiids = AppTester.isKiiidsArt()
    const isGreenAward = AppTester.isGreenAward()
    const is743 = useBreakpoint(LayoutConst.screen.s - 1);

    const { allowedInfo, allowedStatus } = rest;

    // console.log('competition', rest, id)

    const disableMsg: string = useMemo(
        //@ts-ignore
        () => {
            return (
                allowedInfo && !!allowedInfo?.length ? 
                t(`competition.allowed_messages.${allowedInfo?.[0]}_${isModer ? 'moder' : 'user'}`) : 
                '' 
            )

        } , [isModer, t, i18n.language, allowedInfo])


    const allowedProjectsCount = useMemo(
        () => allowedStatus?.allowedMax && allowedStatus?.allowedMax > 0 ? <span>{`${allowedStatus?.allowedCurrent} / ${allowedStatus?.allowedMax}`}</span> : '' 
    , [allowedStatus])

    return (
        <ActionsButtonWrapper>
             <HintTooltip  hidden={disableMsg === '' || isGreenAward} customStyle={getTooltipStyles(theme)} text={disableMsg} z={7} w={is743 ? '100%' : ''} onWhiteBg={true}  {...hintProps}>
            {isModer ? (
                <SendProjectButton
                color={theme.competition.buttonText}
                className='moder-button'
                c={theme.competition.buttonBg}
                hoverC={theme.competition.secondaryText}
                onClick={() => {    
                    history.push('/competition/' + id + "/moder")
                }}
                r="3"
                fullWidth={fullWidth}
            >
                {t('competition.moder')}
                {allowedProjectsCount}
            </SendProjectButton>
            ) : 
            isKiiids ?
            <></>
            :
            (
                <SendProjectButton
                color={theme.competition.buttonText}
                c={theme.competition.buttonBg}
                hoverC={theme.competition.secondaryText}
                disabled={disabled}
                className='send-button'
                fullWidth={fullWidth}
                onClick={() => {
                    if (INTERIOR_DESIGN_COMPETITION_IDS.includes(id)){
                      return history.push('/competitions/application/' + id)
                    }
                    if (needAuth) {
                        return auth.login()
                    }
                    if (GREEN_AWARDS_COMPETITION_IDS.includes(id)){
                        return modal.show('application-form', {
                            nominationIds: [nominationId],
                            callBack: () => window.location.reload(),
                            onClose: () => modal.hide(),
                            competitionId: id
                        })
                    }
                    if (isBriefPreregistration) {
                        const confirm = window.confirm(t('hse_showcases_title.competitions.msg.wont_send_requests'))
                        if (confirm) {
                            try {
                                API.request()
                                .endpoint(Endpoints.competitions)
                                .url('/api/Competition/RequestParticipantToCompetition')
                                .post()
                                .addQuery('competitionId', id || '')
                                .send()
                                .then((r) => {
                                  if (r?.status === 200) {
                                    modal.show('custom-info-modal', {
                                        title: t('hse_showcases_title.competitions.msg.success_brief_send'),
                                        text: t('hse_showcases_title.competitions.msg.success_brief_send_descriptions')
                                    })
                                  }
                      
                                })
                              }
                              catch(err) {
                                console.error('Что-то пошло не так');
                              }

                        }
                        return;
                    }
                    if (isPreRegistration) {
                        modal.show('competition-custom-legals', {
                            nominationIds: [nominationId],
                            callBack: () => window.location.reload(), 
                            onClose: () => modal.hide(),
                            competitionId: id
                        })
                    } else {
                        modal.show(
                            'send-project'
                            , {
                            id,
                            isPreRegistration,
                            isAllowParticipants,
                            onClose: () => modal.hide(),
                        })
                    }
                }} 
                r="3"
                >
                    {text?.length ? text : isAcademy ? t('competition.apply') : t('competition.submit')}
            </SendProjectButton>
            )}
            </HintTooltip>
            <ReactTooltip {...getTooltipStyles(theme as any)} arrowColor='transparent'/>
        </ActionsButtonWrapper>
    )
}

export default React.memo(ActionsButtons);